import { useState } from "react";
import { useGetFaqQuery } from "../../services/store/api/faqApi";
import Loader from "../../components/loader/loader";
import styles from "./faq.module.css";
import { TFaq } from "../../types";
import Heading from "../../components/heading/heading";

const FaqItem = ({ item, isOpen, onToggle }: { item: TFaq; isOpen: boolean; onToggle: () => void }) => {
  return (
    <div className={styles.item}>
      <button className={styles.question} onClick={onToggle}>
        <span>{item.question}</span>
        <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className={styles.answer} dangerouslySetInnerHTML={{ __html: item.answer }} />
      )}
    </div>
  );
};

export function FaqPage() {
  const { data, isLoading, error } = useGetFaqQuery();
  const [openId, setOpenId] = useState<number | null>(null);

  if (isLoading) return (
    <>
      <Heading tpl="new">Вопрос-ответ</Heading>
      <Loader />
    </>
  );
  if (error) return (
    <>
      <Heading tpl="new">Вопрос-ответ</Heading>
      <div className={styles.empty}>Не удалось загрузить вопросы</div>
    </>
  );
  if (!data || !data.length) return (
    <>
      <Heading tpl="new">Вопрос-ответ</Heading>
      <div className={styles.empty}>Пока нет вопросов</div>
    </>
  );

  return (
    <>
      <Heading tpl="new">Вопрос-ответ</Heading>
      <div className={styles.wrapper}>
        {data.map((item) => (
          <FaqItem
            key={item.id}
            item={item}
            isOpen={openId === item.id}
            onToggle={() => setOpenId((prev) => (prev === item.id ? null : item.id))}
          />
        ))}
      </div>
    </>
  );
}

export default FaqPage;
